import { z } from "zod";

const errorMessages = {
  required: "وارد کردن این فیلد اجباری است",
};

const schema = z.object({
  fa_terms: z.string().optional().nullable(),
  en_terms: z.string().optional().nullable(),
  ar_terms: z.string().optional().nullable(),
  start_bachelor_register_date: z.string().min(1, errorMessages.required),
  end_bachelor_register_date: z.string().min(1, errorMessages.required),
  start_register_date: z.string().min(1, errorMessages.required),
  end_register_date: z.string().min(1, errorMessages.required),
  start_phd_register_date: z.string().min(1, errorMessages.required),
  end_phd_register_date: z.string().min(1, errorMessages.required),
});

export { schema };
